import React, { Component } from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import './LoaderComponent.scss';

class LoaderComponent extends Component {
  render() {
    const { spinning, text } = this.props;

    return (
      <div className="LoaderComponent">
        <Spin spinning={spinning} />
        {!!text && spinning && <p>{text}</p>}
      </div>
    );
  }
}

LoaderComponent.defaultProps = {
  spinning: false,
  text: null
};

LoaderComponent.propTypes = {
  spinning: PropTypes.bool,
  text: PropTypes.string
};

export default LoaderComponent;
